import React, { useEffect, useState } from 'react'
import Table from 'react-bootstrap/Table'
import api from './../components/api'
import moment from 'moment'
//import { useTabelaGestao } from '../context/GestaoPendenciasContext'
import { Link } from 'react-router-dom'

import { useEnunciadoContext } from '../context/enunciadoContext'
import { useVerificaDesafioContext } from '../context/verificaDesafioContext'
import { useSecaoEnunciadoContext } from '../context/secaoEnunciadoContext'

import StatusValidacaoSecao from '../components/StatusValidacaoSecao'



const VisaoEstrategica = (props) => {

    //var { atualizacaoGestao, setAtualizacaoGestao } = useTabelaGestao()

    var ano = props.ano
    var adesao_institucional_id = props.adesao_institucional_id


    var { enunciado, setEnunciado } = useEnunciadoContext()
    var { setSecaoEnunciado } = useSecaoEnunciadoContext()
    var { verificaDesafio } = useVerificaDesafioContext()


    const [questao1, setQuestao1] = useState()
    const [questao2, setQuestao2] = useState()
    const [questao3, setQuestao3] = useState()
    const [questao4, setQuestao4] = useState()
    const [questao5, setQuestao5] = useState()
    const [questao6, setQuestao6] = useState()
    const [questao7, setQuestao7] = useState()
    const [questao8, setQuestao8] = useState()
    const [questao9, setQuestao9] = useState()
    
    const [totalPendencias, setTotalPendencias] = useState(0)
    


    //var [adesao_institucional_id, setAdesaoInstitucionalId] = useState(sessionStorage.getItem('adesao_institucional_id'))
    var [compras_id, setCompras_id] = useState()


    var [possuiIniciativas, setPossuiIniciativas] = useState()
    var [inicMissao, setInicMissao] = useState()
    var [inicPolitica, setInicPolitica] = useState()
    var [inicCod, setInicCod] = useState()
    var [inicRel, setInicRel] = useState()
    var [inicComp, setInicComp] = useState()
    var [inicNaoHaDoc, setInicNaoHaDoc] = useState()
    var [inicNaoHaInic, setInicNaoHaInic] = useState()
    var [inicOutra, setInicOutra] = useState()
    var [inicOutraDescri, setInicOutraDescri] = useState()
    var [dirManCompras, setDirManCompras] = useState()
    var [dirManFornecedor, setDirManFornecedor] = useState()
    var [dirNormInt, setDirNormInt] = useState()
    var [dirPOP, setDirPOP] = useState()
    var [dirNaoHaDoc, setDirNaoHaDoc] = useState()
    var [dirNaoForamDef, setDirNaoForamDef] = useState()
    var [dirOutra, setDirOutra] = useState()
    var [dirOutraDescri, setDirOutraDescri] = useState()
    var [ciApoioAltaDirecao, setCiApoioAltaDirecao] = useState('')
    var [ciDispRecursos, setCiDispRecursos] = useState('')
    var [ciAcessoConhecimento, setCiAcessoConhecimento] = useState('')
    var [ciContIniciativas, setCiContIniciativas] = useState('')
    var [ciCompras, setCiCompras] = useState('')
    var [ciSustent, setCiSustent] = useState('')
    var [ciCultOrg, setCultOrg] = useState('')
    var [ciComunic, setCiComunic] = useState('')
    var [ciMonit, setCiMonit] = useState('')
    var [fmComp, setFmComp] = useState()
    var [fmAtendPol, setFmAtendPol] = useState()
    var [fmVal, setFmVal] = useState()
    var [fmPromoCompet, setFmPromoCompet] = useState()
    var [fmExpecSS, setFmExpecSS] = useState()
    var [fmExpecInv, setFmExpecInv] = useState()
    var [fmEngForn, setFmEngForn] = useState()
    var [fmPromoInova, setFmPromoInova] = useState()
    var [fraseDefine, setFraseDefine] = useState()
    var [rtISO, setRtISO] = useState()
    var [rtGuiaCompras, setRtGuiaCompras] = useState()
    var [rtGRI, setRtGRI] = useState()
    var [rtAgendaAmb, setRtAgendaAmb] = useState()
    var [rtIndiceSust, setRtIndiceSust] = useState()
    var [rtIndic, setRtIndic] = useState()
    var [rtPacto, setRtPacto] = useState()
    var [rtAgenda2030, setRtAgenda2030] = useState()
    var [rtNaoUtiliza, setRtNaoUtiza] = useState()
    var [rtNaoRecebeu, setRtNaoRecebeu] = useState()
    var [rtOutra, setRtOutra] = useState()
    var [rtOutraDescri, setRtOutraDescri] = useState()
    //var [procIdentImpactos, setProcIdentImpactos] = useState()
    var [gestaoRiscosImpactos, setGestaoRiscosImpactos] = useState('')
    //var [inicContObjMetas, setInicContObjMetas] = useState()
    var [objMetasIndic, setObjMetasIndic] = useState()


    function salvaVisaoEstrategica() {

        var dataPost = {

            possuiIniciativas: possuiIniciativas,
            inicMissao: inicMissao,
            inicPolitica: inicPolitica,
            inicCod: inicCod,
            inicRel: inicRel,            
            inicNaoHaDoc: inicNaoHaDoc,
            inicNaoHaInic: inicNaoHaInic,
            inicOutra: inicOutra,
            inicOutraDescri: inicOutraDescri,
            dirManCompras: dirManCompras,
            dirManFornecedor: dirManFornecedor,
            dirNormInt: dirNormInt,
            dirPOP: dirPOP,
            dirNaoHaDoc: dirNaoHaDoc,
            dirNaoForamDef: dirNaoForamDef,
            dirOutra: dirOutra,
            dirOutraDescri: dirOutraDescri,
            ciApoioAltaDirecao: ciApoioAltaDirecao,
            ciDispRecursos: ciDispRecursos,
            ciAcessoConhecimento: ciAcessoConhecimento,
            ciContIniciativas: ciContIniciativas,
            ciCompras: ciCompras,
            ciSustent: ciSustent,
            ciCultOrg: ciCultOrg,
            ciComunic: ciComunic,
            ciMonit: ciMonit,
            fmComp: fmComp,
            fmAtendPol: fmAtendPol,
            fmVal: fmVal,
            fmPromoCompet: fmPromoCompet,
            fmExpecSS: fmExpecSS,
            fmExpecInv: fmExpecInv,
            fmEngForn: fmEngForn,
            fmPromoInova: fmPromoInova,
            fraseDefine: fraseDefine,
            rtISO: rtISO,
            rtGuiaCompras: rtGuiaCompras,
            rtGRI: rtGRI,
            rtAgendaAmb: rtAgendaAmb,
            rtIndiceSust: rtIndiceSust,
            rtIndic: rtIndic,
            rtPacto: rtPacto,
            rtAgenda2030: rtAgenda2030,
            rtNaoUtiliza: rtNaoUtiliza,
            rtNaoRecebeu: rtNaoRecebeu,
            rtOutra: rtOutra,
            rtOutraDescri: rtOutraDescri,
            gestaoRiscosImpactos: gestaoRiscosImpactos,
            objMetasIndic: objMetasIndic,

        }

        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma os dados?',
		    buttons: {
		        Sim: function () {


                    if (compras_id) {

                        //console.log('!!')
                        
                        api.put(`comprasVisaoEstrategica/${compras_id}`, dataPost).then((result) => {

                            console.log(result.data)
                            window.toastr.success('Registro salvo com sucesso!')
                            //setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))

                        }).catch((err) => {

                            console.log(err.response)

                        })


                    } else {

                        

                        api.post(`comprasVisaoEstrategica/${adesao_institucional_id}/${ano}`, dataPost).then((result) => {

                            
                            setCompras_id(result.data[0].compras_id)
                            window.toastr.success('Registro salvo com sucesso!')
                            //setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))


                        }).catch((err) => {

                            console.log(err.response)

                        })

                    }


                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


        

        
    }


    async function carregaComprasVisaoEstrategica() {

        setCompras_id()
        setPossuiIniciativas()
        setInicMissao()
        setInicPolitica()
        setInicCod()
        setInicRel()
        setInicComp()
        setInicNaoHaDoc()
        setInicNaoHaInic()
        setInicOutra()
        setInicOutraDescri()
        setDirManCompras()
        setDirManFornecedor()
        setDirNormInt()
        setDirPOP()
        setDirNaoHaDoc()
        setDirNaoForamDef()
        setDirOutra()
        setDirOutraDescri()
        setCiApoioAltaDirecao('')
        setCiDispRecursos('')
        setCiAcessoConhecimento('')
        setCiContIniciativas('')
        setCiCompras('')
        setCiSustent('')
        setCultOrg('')
        setCiComunic('')
        setCiMonit('')
        setFmComp('')
        setFmAtendPol('')
        setFmVal('')
        setFmPromoCompet('')
        setFmExpecSS('')
        setFmExpecInv('')
        setFmEngForn('')
        setFmPromoInova('')
        setFraseDefine()
        setRtISO()
        setRtGuiaCompras()
        setRtGRI()
        setRtAgendaAmb()
        setRtIndiceSust()
        setRtIndic()
        setRtPacto()
        setRtAgenda2030()
        setRtNaoUtiza()
        setRtNaoRecebeu()
        setRtOutra()
        setRtOutraDescri()
        //setProcIdentImpactos(data.procIdentImpactos)
        setGestaoRiscosImpactos()
        setObjMetasIndic()




        if (ano && adesao_institucional_id) {



            //console.log('!!!')
            await api.get(`comprasVisaoEstrategica/${adesao_institucional_id}/${ano}`).then((result) => {

                if (result.data[0]) {

                    //console.log(result.data)

                    //console.log(result.data, '!!')
                    var data = result.data[0]

                    //console.log(data.ciApoioAltaDirecao)
                    setGestaoRiscosImpactos(data.gestaoRiscosImpactos)
                    
                    setCompras_id(data.compras_id)
                    setPossuiIniciativas(data.possuiIniciativas)
                    setInicMissao(data.inicMissao)
                    setInicPolitica(data.inicPolitica)
                    setInicCod(data.inicCod)
                    setInicRel(data.inicRel)
                    setInicComp(data.inicComp)
                    setInicNaoHaDoc(data.inicNaoHaDoc)
                    setInicNaoHaInic(data.inicNaoHaInic)
                    setInicOutra(data.inicOutra)
                    setInicOutraDescri(data.inicOutraDescri)
                    setDirManCompras(data.dirManCompras)
                    setDirManFornecedor(data.dirManFornecedor)
                    setDirNormInt(data.dirNormInt)
                    setDirPOP(data.dirPOP)
                    setDirNaoHaDoc(data.dirNaoHaDoc)
                    setDirNaoForamDef(data.dirNaoForamDef)
                    setDirOutra(data.dirOutra)
                    setDirOutraDescri(data.dirOutraDescri)
                    setCiApoioAltaDirecao(data.ciApoioAltaDirecao)
                    setCiDispRecursos(data.ciDispRecursos)
                    setCiAcessoConhecimento(data.ciAcessoConhecimento)
                    setCiContIniciativas(data.ciContIniciativas)
                    setCiCompras(data.ciCompras)
                    setCiSustent(data.ciSustent)
                    setCultOrg(data.ciCultOrg)
                    setCiComunic(data.ciComunic)
                    setCiMonit(data.ciMonit)
                    setFmComp(data.fmComp)
                    setFmAtendPol(data.fmAtendPol)
                    setFmVal(data.fmVal)
                    setFmPromoCompet(data.fmPromoCompet)
                    setFmExpecSS(data.fmExpecSS)
                    setFmExpecInv(data.fmExpecInv)
                    setFmEngForn(data.fmEngForn)
                    setFmPromoInova(data.fmPromoInova)
                    setFraseDefine(data.fraseDefine)
                    setRtISO(data.rtISO)
                    setRtGuiaCompras(data.rtGuiaCompras)
                    setRtGRI(data.rtGRI)
                    setRtAgendaAmb(data.rtAgendaAmb)
                    setRtIndiceSust(data.rtIndiceSust)
                    setRtIndic(data.rtIndic)
                    setRtPacto(data.rtPacto)
                    setRtAgenda2030(data.rtAgenda2030)
                    setRtNaoUtiza(data.rtNaoUtiliza)
                    setRtNaoRecebeu(data.rtNaoRecebeu)
                    setRtOutra(data.rtOutra)
                    setRtOutraDescri(data.rtOutraDescri)
                    setObjMetasIndic(data.objMetasIndic)
                    //setProcIdentImpactos(data.procIdentImpactos)
                    
                    //setInicContObjMetas(data.inicContObjMetas)
                    //setObbjMetasIndic(data.objMetasIndic)

                }
            })

        }
    }


    useEffect(() => {
        
        //console.log(ano, adesao_institucional_id)
        carregaComprasVisaoEstrategica()


        setQuestao1()
        setQuestao2()
        setQuestao3()
        setQuestao4()
        setQuestao5()
        setQuestao6()
        setQuestao7()
        setQuestao8()
        setQuestao9()
        
        


    }, [ano, adesao_institucional_id])




    const verificaValidacoes = () => {

        //console.log('verificado')

        setQuestao1()
        setQuestao2()
        setQuestao3()
        setQuestao4()
        setQuestao5()
        setQuestao6()
        setQuestao7()
        setQuestao8()
        setQuestao9()
        
        

        if (compras_id) {

            var dataPost = {

                formulario_id: compras_id,
                desafio: 'Compras',

            }

            api.post('desafioValidaVarios', dataPost).then((result) => {

                
                var data = result.data
                console.log(data)
                var totalErros = 0

                for (var k = 0; k < data.length; k++) {

                    if (data[k].status == 'Erro') {


                        switch (data[k].enunciado) {

                            case '1. Sua organização possui iniciativas em Compras Sustentáveis?':

                                totalErros = totalErros + 1
                                setQuestao1('red')
    
                            break

                            case '2. As iniciativas em Compras Sustentáveis promovidas por sua organização são embasadas por: (Assinale todas as opções aplicáveis)':

                                totalErros = totalErros + 1
                                setQuestao2('red')

                            break

                            case '3. As diretrizes para Compras Sustentáveis encontram-se descritas em quais documentos? (Assinale todas as opções aplicáveis)':

                                totalErros = totalErros + 1
                                setQuestao3('red')

                            break

                            case '4. Quanto às condições internas que contribuem para o desenvolvimento das Compras Sustentáveis em sua organização, como você avalia as opções abaixo?':

                                totalErros = totalErros + 1
                                setQuestao4('red')

                            break

                            case '5. Quanto aos fatores que motivam a adoção de Compras Sustentáveis em sua organização, como você avalia as opções abaixo?':

                                totalErros = totalErros + 1
                                setQuestao5('red')

                            break

                            case '6. Que frase melhor define o estágio da sua organização no tocante às Compras Sustentáveis?':

                                totalErros = totalErros + 1
                                setQuestao6('red')

                            break

                            case '7. Quais referências técnicas são utilizadas por sua organização para Compras Sustentáveis? (Assinale todas as opções aplicáveis)':

                                totalErros = totalErros + 1
                                setQuestao7('red')

                            break

                            case '8. Sua organização realiza gestão dos riscos relacionados à sustentabilidade em suas compras e contratações, a partir dos impactos identificados?':

                                totalErros = totalErros + 1
                                setQuestao8('red')

                            break

                            case '9. Os objetivos e/ou metas para Compras Sustentáveis estão citados entre os indicadores estratégicos da organização?':

                                totalErros = totalErros + 1
                                setQuestao9('red')

                            break


                        }

                    }

                    

                }

                setTotalPendencias(totalErros)

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }


    useEffect(() => {

        verificaValidacoes()

    }, [compras_id, verificaDesafio])




    return (

        <div>

        

            <div className="col-md-12">

                
                <Table striped bordered hover>
                    
                    <tbody>
                        <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="2">

                            <Link style={{ color: questao1 }} onClick={() => {setEnunciado('1. Sua organização possui iniciativas em Compras Sustentáveis?');setSecaoEnunciado('Seção I');window.$('#modalValidacao').modal('show')}}>
                            1. Sua organização possui iniciativas em Compras Sustentáveis?                            
                            </Link>
                           
                            </td>
                        </tr>
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="possuiIniciativas" onClick={() => setPossuiIniciativas('S')} checked={ possuiIniciativas == 'S' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                                Sim, possui iniciativas em Compras Sustentáveis formalmente instituídas
                            </td>
                            
                        </tr>         
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="possuiIniciativas" onClick={() => setPossuiIniciativas('F')} checked={ possuiIniciativas == 'F' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                                Possui iniciativas em Compras Sustentáveis, mas não formalmente instituídas
                            </td>
                            
                        </tr>      
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="possuiIniciativas" onClick={() => setPossuiIniciativas('P')} checked={ possuiIniciativas == 'P' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                                As iniciativas em Compras Sustentáveis encontram-se em fase de planejamento
                            </td>
                            
                        </tr>      
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="possuiIniciativas" onClick={() => setPossuiIniciativas('N')} checked={ possuiIniciativas == 'N' ? 1 : 0}  disabled />
                                </center>
                            </td>
                            <td>
                                Não há iniciativas em Compras Sustentáveis
                            </td>
                            
                        </tr>            
                        

                    </tbody>
                </Table>

            </div>


            <div className="col-md-12">


                <Table striped bordered hover>
                    
                    <tbody>
                        <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                            <Link style={{ color: questao2 }} onClick={() => {setEnunciado('2. As iniciativas em Compras Sustentáveis promovidas por sua organização são embasadas por: (Assinale todas as opções aplicáveis)');setSecaoEnunciado('Seção I');window.$('#modalValidacao').modal('show')}}>
                            2. As iniciativas em Compras Sustentáveis promovidas por sua organização são embasadas por: (Assinale todas as opções aplicáveis)
                            </Link>
                            </td>
                        </tr>
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="inicMissao" value={inicMissao} onChange={event => setInicMissao(event.target.checked)} checked={ inicMissao ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Missão, visão, valores
                            </td>
                            
                        </tr>         
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" id="inicPolitica" value={inicPolitica} onChange={event => setInicPolitica(event.target.checked)} checked={ inicPolitica ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                                Política de Compras
                            </td>
                            
                        </tr>      
                           
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" id="inicCod" value={inicCod} onChange={event => setInicCod(event.target.checked)} checked={ inicCod ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                                Código de Conduta
                            </td>
                            
                        </tr>           
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" id="inicRel" value={inicRel} onChange={event => setInicRel(event.target.checked)} checked={ inicRel ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                                Relatórios de atividades às partes interessadas
                            </td>
                            
                        </tr>     
                        <tr >
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" id="inicComp" value={inicComp} onChange={event => setInicComp(event.target.checked)} checked={ inicComp ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            <span class="wrapper2">Compromissos públicos voluntários
                                <div class="tooltip">
                                    Mecanismos para adesão formal de uma instituição a iniciativas e pactos multisetoriais voltados ao atingimento de objetivos comuns e de interesse público local, regional ou global (p.ex: ODS, Pacto Global, Race to Zero).
                                </div>
                            </span>
                            </td>
                            
                        </tr>         
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" id="inicNaoHaDoc" value={inicNaoHaDoc} onChange={event => setInicNaoHaDoc(event.target.checked)} checked={ inicNaoHaDoc ? 1 : 0}  disabled />
                                </center>
                            </td>
                            <td>
                                Não há documento explicitando as iniciativas em Compras Sustentáveis
                            </td>
                            
                        </tr>    
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" id="inicNaoHaInic" value={inicNaoHaInic} onChange={event => setInicNaoHaInic(event.target.checked)} checked={ inicNaoHaInic ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                                Não há iniciativas em Compras Sustentáveis
                            </td>
                            
                        </tr>    
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" id="inicOutra" value={inicOutra} onChange={event => setInicOutra(event.target.checked)} checked={ inicOutra ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Outra
                            </td>
                            
                        </tr>   
                        <tr style={{ display: inicOutra ? 'block' : 'none' }}>
                            <td colspan="2">
                                <input type="text" class="form_text" id="inicOutraDescri" placeholder="Informe..." maxlength="255" value={inicOutraDescri} onChange={event => setInicOutraDescri(event.target.value)} disabled />
                            </td>
                        </tr>
                         
                        

                    </tbody>
                </Table>
                
            </div>


            <div className="col-md-12">


                <Table striped bordered hover>
                    
                    <tbody>
                        <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                            <Link style={{ color: questao3 }} onClick={() => {setEnunciado('3. As diretrizes para Compras Sustentáveis encontram-se descritas em quais documentos? (Assinale todas as opções aplicáveis)');setSecaoEnunciado('Seção I');window.$('#modalValidacao').modal('show')}}>
                            3. As diretrizes para Compras Sustentáveis encontram-se descritas em quais documentos? (Assinale todas as opções aplicáveis)
                            </Link>
                            </td>
                        </tr>
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="dirManCompras" value={dirManCompras} onChange={event => setDirManCompras(event.target.checked)} checked={ dirManCompras ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Manual de Compras  
                            </td>
                            
                        </tr>         
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="dirManFornecedor"  value={dirManFornecedor} onChange={event => setDirManFornecedor(event.target.checked)} checked={ dirManFornecedor ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Manual do Fornecedor
                            </td>
                            
                        </tr>     
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="dirNormInt" value={dirNormInt} onChange={event => setDirNormInt(event.target.checked)} checked={ dirNormInt ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Normativas internas
                            </td>
                            
                        </tr>   
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="dirPOP" value={dirPOP} onChange={event => setDirPOP(event.target.checked)} checked={ dirPOP ? 1 : 0}  disabled />
                                </center>
                            </td>
                            <td>
                            Procedimento Operacional Padrão
                            </td>
                            
                        </tr>   
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="dirNaoHaDoc"  value={dirNaoHaDoc} onChange={event => setDirNaoHaDoc(event.target.checked)} checked={ dirNaoHaDoc ? 1 : 0}  disabled />
                                </center>
                            </td>
                            <td>
                            Não há um documento com diretrizes sobre Compras Sustentáveis
                            </td>
                            
                        </tr>   
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="dirNaoForamDef" value={dirNaoForamDef} onChange={event => setDirNaoForamDef(event.target.checked)} checked={ dirNaoForamDef ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Ainda não foram definidas diretrizes para Compras Sustentáveis
                            </td>
                            
                        </tr>  
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="dirOutra" value={dirOutra} onChange={event => setDirOutra(event.target.checked)} checked={ dirOutra ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Outra
                            </td>
                            
                        </tr>  
                        <tr style={{ display: dirOutra ? 'table-row' : 'none' }}>
                            <td colspan="2">
                                <input type="text" class="form_text" id="dirOutraDescri" placeholder="Informe..." maxlength="255" value={dirOutraDescri} onChange={event => setDirOutraDescri(event.target.value)} disabled />
                            </td>
                        </tr>
                         
                        

                    </tbody>
                </Table>
                
            </div>

            <div className="col-md-12">


                <Table striped bordered hover>
                    
                    <tbody>
                        <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                            <Link style={{ color: questao4 }} onClick={() => {setEnunciado('4. Quanto às condições internas que contribuem para o desenvolvimento das Compras Sustentáveis em sua organização, como você avalia as opções abaixo?');setSecaoEnunciado('Seção I');window.$('#modalValidacao').modal('show')}}>
                            4. Quanto às condições internas que contribuem para o desenvolvimento das Compras Sustentáveis em sua organização, como você avalia as opções abaixo?
                            </Link>
                            </td>
                        </tr>
                        
                        <tr>
                            <td  style={{width: '520px'}}>
                                <center>
                                    <div align="right">
                                        Apoio da alta direção
                                    </div>
                                </center>
                            </td>
                            <td>
                                <select id="ciApoioAltaDirecao" value={ciApoioAltaDirecao} onChange={event => setCiApoioAltaDirecao(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="P"  >Perfeitamente Suficiente</option>
                                    <option value="S"  >Suficiente</option>
                                    <option value="M"  >Mediano</option>
                                    <option value="N"  >Poderia melhorar</option>
                                    <option value="O"  >Poderia melhorar muito</option>
                                </select>
                            </td>
                            
                        </tr>     
                        <tr>
                            <td  style={{width: '520px'}}>
                                <div align="right">
                                    Disponibilidade de recursos financeiros
                                </div>
                            </td>
                            <td>
                                <select id="ciDispRecursos" value={ciDispRecursos} onChange={event => setCiDispRecursos(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="P"  >Perfeitamente Suficiente</option>
                                    <option value="S"  >Suficiente</option>
                                    <option value="M"  >Mediano</option>
                                    <option value="N"  >Poderia melhorar</option>
                                    <option value="O"  >Poderia melhorar muito</option>
                                </select>
                            </td>
                            
                        </tr>       
                        <tr>
                            <td  style={{width: '520px'}}>
                                <div align="right">
                                    Acesso a conhecimento especializado
                                </div>
                            </td>
                            <td>
                                <select id="ciAcessoConhecimento" value={ciAcessoConhecimento} onChange={event => setCiAcessoConhecimento(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="P"  >Perfeitamente Suficiente</option>
                                    <option value="S"  >Suficiente</option>
                                    <option value="M"  >Mediano</option>
                                    <option value="N"  >Poderia melhorar</option>
                                    <option value="O"  >Poderia melhorar muito</option>
                                </select>
                            </td>
                            
                        </tr>       
                        <tr>
                            <td  style={{width: '520px'}}>
                                <div align="right">
                                    Continuidade de iniciativas implementadas
                                </div>
                            </td>
                            <td>
                                <select id="ciContIniciativas" value={ciContIniciativas} onChange={event => setCiContIniciativas(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="P"  >Perfeitamente Suficiente</option>
                                    <option value="S"  >Suficiente</option>
                                    <option value="M"  >Mediano</option>
                                    <option value="N"  >Poderia melhorar</option>
                                    <option value="O"  >Poderia melhorar muito</option>
                                </select>
                            </td>
                            
                        </tr>    
                        <tr>
                            <td  style={{width: '520px'}}>
                                <div align="right">
                                    Diretrizes claras para Compras Sustentáveis
                                </div>
                            </td>
                            <td>
                                <select id="ciCompras" value={ciCompras} onChange={event => setCiCompras(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="P"  >Perfeitamente Suficiente</option>
                                    <option value="S"  >Suficiente</option>
                                    <option value="M"  >Mediano</option>
                                    <option value="N"  >Poderia melhorar</option>
                                    <option value="O"  >Poderia melhorar muito</option>
                                </select>
                            </td>
                            
                        </tr>  
                        <tr>
                            <td  style={{width: '520px'}}>
                                <div align="right">
                                    Diretrizes claras para Sustentabilidade
                                </div>
                            </td>
                            <td>
                                <select id="ciSustent" value={ciSustent} onChange={event => setCiSustent(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="P"  >Perfeitamente Suficiente</option>
                                    <option value="S"  >Suficiente</option>
                                    <option value="M"  >Mediano</option>
                                    <option value="N"  >Poderia melhorar</option>
                                    <option value="O"  >Poderia melhorar muito</option>
                                </select>
                            </td>
                            
                        </tr>  
                        <tr>
                            <td  style={{width: '520px'}}>
                                <div align="right">
                                        <span class="wrapper2">Cultura organizacional
                            <div class="tooltip">
                                Conceito por meio do qual uma organização estabelece as formas de comunicação de seus objetivos e de relacionamento entre as pessoas que a integram visando ao atingimento de tais objetivos.
                            </div>
                        </span> para as Compras Sustentáveis
                                </div>
                            </td>
                            <td>
                                <select id="ciCultOrg" value={ciCultOrg} onChange={event => setCultOrg(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="P"  >Perfeitamente Suficiente</option>
                                    <option value="S"  >Suficiente</option>
                                    <option value="M"  >Mediano</option>
                                    <option value="N"  >Poderia melhorar</option>
                                    <option value="O"  >Poderia melhorar muito</option>
                                </select>
                            </td>
                            
                        </tr>  
                        <tr>
                            <td  style={{width: '520px'}}>
                                <div align="right">
                                    Comunicação e engajamento das partes interessadas
                                </div>
                            </td>
                            <td>
                                <select id="ciComunic" value={ciComunic} onChange={event => setCiComunic(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="P"  >Perfeitamente Suficiente</option>
                                    <option value="S"  >Suficiente</option>
                                    <option value="M"  >Mediano</option>
                                    <option value="N"  >Poderia melhorar</option>
                                    <option value="O"  >Poderia melhorar muito</option>
                                </select>
                            </td>
                            
                        </tr> 
                        <tr>
                            <td  style={{width: '520px'}}>
                                <div align="right">
                                Monitoramento dos resultados em Compras Sustentáveis
                                </div>
                            </td>
                            <td>
                                <select id="ciMonit"  value={ciMonit} onChange={event => setCiMonit(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="P"  >Perfeitamente Suficiente</option>
                                    <option value="S"  >Suficiente</option>
                                    <option value="M"  >Mediano</option>
                                    <option value="N"  >Poderia melhorar</option>
                                    <option value="O"  >Poderia melhorar muito</option>
                                </select>
                            </td>
                            
                        </tr> 
                        
                        
                         
                        

                    </tbody>
                </Table>
                
            </div>

            <div className="col-md-12">


                <Table striped bordered hover>
                    
                    <tbody>
                        <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                            <Link style={{ color: questao5 }} onClick={() => {setEnunciado('5. Quanto aos fatores que motivam a adoção de Compras Sustentáveis em sua organização, como você avalia as opções abaixo?');setSecaoEnunciado('Seção I');window.$('#modalValidacao').modal('show')}}>
                            5. Quanto aos fatores que motivam a adoção de Compras Sustentáveis em sua organização, como você avalia as opções abaixo?
                            </Link>
                            </td>
                        </tr>
                        
                        <tr>
                            <td  style={{width: '520px'}}>
                                <center>
                                    <div align="right">
                                        Compromissos corporativos de sustentabilidade
                                    </div>
                                </center>
                            </td>
                            <td>
                                <select id="fmComp" value={fmComp} onChange={event => setFmComp(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="D"  >É fator determinante</option>
                                    <option value="M"  >Motiva muito</option>
                                    <option value="I"  >Indiferente</option>
                                    <option value="P"  >Motiva pouco</option>
                                    <option value="N"  >Não motiva</option>
                                </select>
                            </td>
                            
                        </tr>  
                        <tr>
                            <td  style={{width: '520px'}}>
                                <center>
                                    <div align="right">
                                        Atendimento a Políticas Públicas de caráter socioambiental (ex.: Clima, Resíduos, Direitos Humanos)
                                    </div>
                                </center>
                            </td>
                            <td>
                                <select id="fmAtendPol" value={fmAtendPol} onChange={event => setFmAtendPol(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="D"  >É fator determinante</option>
                                    <option value="M"  >Motiva muito</option>
                                    <option value="I"  >Indiferente</option>
                                    <option value="P"  >Motiva pouco</option>
                                    <option value="N"  >Não motiva</option>
                                </select>
                            </td>
                            
                        </tr>  
                        <tr>
                            <td  style={{width: '520px'}}>
                                <center>
                                    <div align="right">
                                        Valorização da imagem ou reputação
                                    </div>
                                </center>
                            </td>
                            <td>
                                <select id="fmVal" value={fmVal} onChange={event => setFmVal(event.target.value)} disabled>
                                    <option value="" >[Selecione]</option>
                                    <option value="D"  >É fator determinante</option>
                                    <option value="M"  >Motiva muito</option>
                                    <option value="I"  >Indiferente</option>
                                    <option value="P"  >Motiva pouco</option>
                                    <option value="N"  >Não motiva</option>
                                </select>
                            </td>
                            
                        </tr>  
                        <tr>
                            <td  style={{width: '520px'}}>
                                <center>
                                    <div align="right">
                                    Promoção de&nbsp;
                                    <span class="wrapper2">vantagem competitiva
                                        <div class="tooltip">
                                            Vantagem competitiva corresponde a vantagem que uma empresa tem em relação aos seus concorrentes, a partir de atributos (ou conjunto de características) que a posicionam à frente e de forma diferenciada em relação aos seus concorrentes no mercado.
                                        </div>
                                    </span>
                                    </div>
                                </center>
                            </td>
                            <td>
                                <select id="fmPromoCompet" value={fmPromoCompet} onChange={event => setFmPromoCompet(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="D"  >É fator determinante</option>
                                    <option value="M"  >Motiva muito</option>
                                    <option value="I"  >Indiferente</option>
                                    <option value="P"  >Motiva pouco</option>
                                    <option value="N"  >Não motiva</option>
                                </select>
                            </td>
                            
                        </tr>  

                        <tr>
                            <td  style={{width: '520px'}}>
                                <center>
                                    <div align="right">
                                        Atendimento às expectativas dos usuários dos serviços de saúde
                                    </div>
                                </center>
                            </td>
                            <td>
                                <select id="fmExpecSS" value={fmExpecSS} onChange={event => setFmExpecSS(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="D"  >É fator determinante</option>
                                    <option value="M"  >Motiva muito</option>
                                    <option value="I"  >Indiferente</option>
                                    <option value="P"  >Motiva pouco</option>
                                    <option value="N"  >Não motiva</option>
                                </select>
                            </td>
                            
                        </tr>  

                        <tr>
                            <td  style={{width: '520px'}}>
                                <center>
                                    <div align="right">
                                        Atendimento às expectativas de investidores/financiadores
                                    </div>
                                </center>
                            </td>
                            <td>
                                <select id="fmExpecInv" value={fmExpecInv} onChange={event => setFmExpecInv(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="D"  >É fator determinante</option>
                                    <option value="M"  >Motiva muito</option>
                                    <option value="I"  >Indiferente</option>
                                    <option value="P"  >Motiva pouco</option>
                                    <option value="N"  >Não motiva</option>
                                </select>
                            </td>
                            
                        </tr>  

                        <tr>
                            <td  style={{width: '520px'}}>
                                <center>
                                    <div align="right">
                                        Engajamento dos fornecedores
                                    </div>
                                </center>
                            </td>
                            <td>
                                <select id="fmEngForn"  value={fmEngForn} onChange={event => setFmEngForn(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="D"  >É fator determinante</option>
                                    <option value="M"  >Motiva muito</option>
                                    <option value="I"  >Indiferente</option>
                                    <option value="P"  >Motiva pouco</option>
                                    <option value="N"  >Não motiva</option>
                                </select>
                            </td>
                            
                        </tr>  
                        <tr>
                            <td  style={{width: '520px'}}>
                                <center>
                                    <div align="right">
                                        Promoção da inovação
                                    </div>
                                </center>
                            </td>
                            <td>
                                <select id="fmPromoInova" value={fmPromoInova} onChange={event => setFmPromoInova(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="D"  >É fator determinante</option>
                                    <option value="M"  >Motiva muito</option>
                                    <option value="I"  >Indiferente</option>
                                    <option value="P"  >Motiva pouco</option>
                                    <option value="N"  >Não motiva</option>
                                </select>
                            </td>
                            
                        </tr>  

                    </tbody>
                </Table>

            </div>


            <div className="col-md-12">


                <Table striped bordered hover>
                    
                    <tbody>
                        <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                            <Link style={{ color: questao6 }} onClick={() => {setEnunciado('6. Que frase melhor define o estágio da sua organização no tocante às Compras Sustentáveis?');setSecaoEnunciado('Seção I');window.$('#modalValidacao').modal('show')}}>
                            6. Que frase melhor define o estágio da sua organização no tocante às Compras Sustentáveis? 
                            </Link>
                            </td>
                        </tr>
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="fraseDefine" onClick={() => setFraseDefine('R')} checked={ fraseDefine == 'R' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                                A organização é considerada referência em Compras Sustentáveis, influenciando a cadeia de valor, incentivando melhorias e inovação e influenciando políticas públicas
                            </td>
                            
                        </tr>    
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="fraseDefine" onClick={() => setFraseDefine('I')} checked={ fraseDefine == 'I' ? 1 : 0} disabled/>
                                </center>
                            </td>
                            <td>
                            As Compras Sustentáveis integram a visão e estratégia corporativa
                            </td>
                            
                        </tr>         
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="fraseDefine" onClick={() => setFraseDefine('C')} checked={ fraseDefine == 'C' ? 1 : 0} disabled/>
                                </center>
                            </td>
                            <td>
                            Os critérios de sustentabilidade vêm sendo incorporados aos processos de compras e contratações de forma gradual
                            </td>
                            
                        </tr>     
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="fraseDefine" onClick={() => setFraseDefine('E')} checked={ fraseDefine == 'E' ? 1 : 0} disabled/>
                                </center>
                            </td>
                            <td>
                            A organização entende que a inclusão dos&nbsp;
                            <span class="wrapper2">critérios de sustentabilidade
                                <div class="tooltip">
                                    Atributos de produtos e serviços voltados à minimização de impactos ambientais negativos, à maximização de impactos sociais positivos e à obtenção do melhor custo-benefício ao longo do ciclo de vida dos produtos ou serviços. Exemplos: Economia de água, eficiência energética, redução da emissão de GEE, redução de toxicidade, valorização de políticas sociais, atendimento a princípios de equidade e justiça social, dentre outros.
                                </div>
                                </span>&nbsp;nas atividades de compras e contratações é importante e começa a avaliar iniciativas neste sentido
                            </td>
                            
                        </tr>   
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="fraseDefine" onClick={() => setFraseDefine('A')} checked={ fraseDefine == 'A' ? 1 : 0} disabled/>
                                </center>
                            </td>
                            <td>
                            Há resistência na organização quanto à adoção de critérios de sustentabilidade nas compras e contratações
                            </td>
                            
                        </tr>   
                        
                        

                    </tbody>
                </Table>
                
            </div>

            <div className="col-md-12">


                <Table striped bordered hover>
                    
                    <tbody>
                        <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                            <Link style={{ color: questao7 }} onClick={() => {setEnunciado('7. Quais referências técnicas são utilizadas por sua organização para Compras Sustentáveis? (Assinale todas as opções aplicáveis)');setSecaoEnunciado('Seção I');window.$('#modalValidacao').modal('show')}}>
                            7. Quais referências técnicas são utilizadas por sua organização para Compras Sustentáveis? (Assinale todas as opções aplicáveis)
                            </Link>
                            </td>
                        </tr>
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="rtISO" value={rtISO} onChange={event => setRtISO(event.target.checked)} checked={ rtISO ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                                Norma ISO/ABNT 20400 – Compras Sustentáveis
                            </td>
                            
                        </tr>  
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="rtGuiaCompras" value={rtGuiaCompras} onChange={event => setRtGuiaCompras(event.target.checked)} checked={ rtGuiaCompras ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                                Guia de Compras Sustentáveis para o Setor Saúde (HCWH, Practice Greenhealth)
                            </td>
                            
                        </tr>  
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="rtGRI" value={rtGRI} onChange={event => setRtGRI(event.target.checked)} checked={ rtGRI ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                                Global Reporting Initiative (GRI)
                            </td>
                            
                        </tr>  
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="rtAgendaAmb" value={rtAgendaAmb} onChange={event => setRtAgendaAmb(event.target.checked)} checked={ rtAgendaAmb ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                                Agenda Ambiental na Administração Pública (A3P)
                            </td>
                            
                        </tr>  
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="rtIndiceSust" value={rtIndiceSust} onChange={event => setRtIndiceSust(event.target.checked)} checked={ rtIndiceSust ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                                Índice de Sustentabilidade Empresarial (ISE B3)
                            </td>
                            
                        </tr>  
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="rtIndic" value={rtIndic} onChange={event => setRtIndic(event.target.checked)} checked={ rtIndic ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                                Indicadores Ethos
                            </td>
                            
                        </tr>  
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="rtPacto" value={rtPacto} onChange={event => setRtPacto(event.target.checked)} checked={ rtPacto ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                                Pacto Global da ONU
                            </td>
                            
                        </tr>  
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="rtAgenda2030" value={rtAgenda2030} onChange={event => setRtAgenda2030(event.target.checked)} checked={ rtAgenda2030 ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                                Agenda 2030 da ONU
                            </td>
                            
                        </tr>  
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="rtNaoUtiliza" value={rtNaoUtiliza} onChange={event => setRtNaoUtiza(event.target.checked)} checked={ rtNaoUtiliza ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                                Não utilizamos referências técnicas para Compras Sustentáveis
                            </td>
                            
                        </tr>  
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="rtNaoRecebeu" value={rtNaoRecebeu} onChange={event => setRtNaoRecebeu(event.target.checked)} checked={ rtNaoRecebeu ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                                A organização ainda não estabeleceu iniciativas em Compras Sustentáveis
                            </td>
                            
                        </tr>  
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="rtOutra" value={rtOutra} onChange={event => setRtOutra(event.target.checked)} checked={ rtOutra ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                                Outra
                            </td>
                            
                        </tr>  
                        <tr style={{ display: rtOutra ? 'table-row' : 'none' }}>
                            <td colspan="2">
                                <input type="text" class="form_text" id="rtOutraDescri" placeholder="Informe..." maxlength="255" value={rtOutraDescri} onChange={event => setRtOutraDescri(event.target.value)} disabled />
                            </td>
                        </tr>

                    </tbody>

                </Table>

            </div>

            <div className="col-md-12">


                <Table striped bordered hover>
                    
                    <tbody>
                        <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                            <Link style={{ color: questao8 }} onClick={() => {setEnunciado('8. Sua organização realiza gestão dos riscos relacionados à sustentabilidade em suas compras e contratações, a partir dos impactos identificados?');setSecaoEnunciado('Seção I');window.$('#modalValidacao').modal('show')}}>
                            8. Sua organização realiza gestão dos riscos relacionados à sustentabilidade em suas compras e contratações, a partir dos impactos identificados?
                            </Link>
                            </td>
                        </tr>
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="gestaoRiscosImpactos" onChange={() => setGestaoRiscosImpactos('S')} checked={ gestaoRiscosImpactos == 'S' ? 1 : 0}  disabled/>
                                </center>
                            </td>
                            <td>
                                Sim, riscos e oportunidades foram mapeados, priorizados e estão sendo monitorados
                            </td>
                            
                        </tr>  
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="gestaoRiscosImpactos" onChange={() => setGestaoRiscosImpactos('R')} checked={ gestaoRiscosImpactos == 'R' ? 1 : 0}  disabled/>
                                </center>
                            </td>
                            <td>
                                Sim, riscos e oportunidades foram mapeados e priorizados
                            </td>
                            
                        </tr>  
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="gestaoRiscosImpactos" onChange={() => setGestaoRiscosImpactos('M')} checked={ gestaoRiscosImpactos == 'M' ? 1 : 0}  disabled/>
                                </center>
                            </td>
                            <td>
                                Sim, riscos e oportunidades foram mapeados
                            </td>
                            
                        </tr>  
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="gestaoRiscosImpactos" onChange={() => setGestaoRiscosImpactos('N')} checked={ gestaoRiscosImpactos == 'N' ? 1 : 0} disabled/>
                                </center>
                            </td>
                            <td>
                                Não, a organização não realiza a gestão de riscos relacionados à sustentabilidade em suas compras e contratações
                            </td>
                            
                        </tr>  
                        

                    </tbody>

                </Table>

            </div>

            <div className="col-md-12">


                <Table striped bordered hover>
                    
                    <tbody>
                        <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                            <Link style={{ color: questao9 }} onClick={() => {setEnunciado('9. Os objetivos e/ou metas para Compras Sustentáveis estão citados entre os indicadores estratégicos da organização?');setSecaoEnunciado('Seção I');window.$('#modalValidacao').modal('show')}}>
                                9. Os objetivos e/ou metas para Compras Sustentáveis estão citados entre os indicadores estratégicos da organização?
                            </Link>
                            </td>
                        </tr>   
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="objMetasIndic" onChange={() => setObjMetasIndic('S')} checked={ objMetasIndic == 'S' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                                Sim, estão citados entre os indicadores estratégicos da organização
                            </td>
                            
                        </tr>  
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="objMetasIndic" onChange={() => setObjMetasIndic('N')} checked={ objMetasIndic == 'N' ? 1 : 0}   disabled />
                                </center>
                            </td>
                            <td>
                                Não, a organização definiu objetivos e metas para Compras Sustentáveis, mas estes não estão entre os indicadores estratégicos.
                            </td>
                            
                        </tr>  
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="objMetasIndic" onChange={() => setObjMetasIndic('P')} checked={ objMetasIndic == 'P' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                                Não, porque os objetivos e metas para as iniciativas em Compras Sustentáveis ainda estão em fase de planejamento / implementação
                            </td>
                            
                        </tr>  
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="objMetasIndic" onChange={() => setObjMetasIndic('O')} checked={ objMetasIndic == 'O' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                                Não, porque a organização não definiu objetivos e metas para Compras Sustentáveis
                            </td>
                            
                        </tr>  

                    </tbody>
                </Table>



            </div>

            <StatusValidacaoSecao desafio="Compras" secaoCampo="secaoI" totalPendencias={totalPendencias} nomeDesafio="Desafio Compras" formulario_id={compras_id} secao="Seçao I - Visão Estratégica" ano={ano} />

        </div>
    )

}

export default VisaoEstrategica